// extracted by mini-css-extract-plugin
module.exports = {"block":"_20EQAh","block__text":"_3LKsnO"};